import { render, staticRenderFns } from "./category.vue?vue&type=template&id=d4b7bfa4&"
import script from "./category.vue?vue&type=script&lang=js&"
export * from "./category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4b7bfa4')) {
      api.createRecord('d4b7bfa4', component.options)
    } else {
      api.reload('d4b7bfa4', component.options)
    }
    module.hot.accept("./category.vue?vue&type=template&id=d4b7bfa4&", function () {
      api.rerender('d4b7bfa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/category.vue"
export default component.exports